const timelineLayoutOptions = {
  CLEAR_ALL: "clearAll",
  COMPACT: "compact",
  WATERFALL: "waterfall"
};

export default timelineLayoutOptions;

export const labelForTimelineLayout = value => {
  switch (value) {
    case timelineLayoutOptions.COMPACT:
      return "Compact";
    case timelineLayoutOptions.WATERFALL:
      return "Waterfall";
    case timelineLayoutOptions.CLEAR_ALL:
    default:
      return "Expanded";
  }
};

export const iconForTimelineLayout = value => {
  switch (value) {
    case timelineLayoutOptions.COMPACT:
      return "footerTimelineLayoutCompact";
    case timelineLayoutOptions.WATERFALL:
      return "footerTimelineLayoutWaterfall";
    case timelineLayoutOptions.CLEAR_ALL:
    default:
      return "footerTimelineLayoutExpanded";
  }
};

export const descriptionForTimelineLayout = value => {
  switch (value) {
    case timelineLayoutOptions.COMPACT:
      return "Items are placed at the highest position they will fit. Recommended with Show Marker Only mode.";
    case timelineLayoutOptions.WATERFALL:
      return "Items return to top when all subsequent items can flow underneath. More compact, but less stable when zooming.";
    case timelineLayoutOptions.CLEAR_ALL:
    default:
      return "Items go underneath previous item unless they are clear of all earlier items.";
  }
};

const createTimelineLayoutDropdownOption = id => {
  return {
    identifier: id,
    name: labelForTimelineLayout(id),
    description: descriptionForTimelineLayout(id)
  };
};

export const TimelineLayoutDropdownOptions = [
  createTimelineLayoutDropdownOption(timelineLayoutOptions.CLEAR_ALL),
  createTimelineLayoutDropdownOption(timelineLayoutOptions.WATERFALL),
  createTimelineLayoutDropdownOption(timelineLayoutOptions.COMPACT)
];
